"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Installments_1 = require("./Installments");
exports.Installments = Installments_1.default;
var Field_1 = require("./Field");
exports.Field = Field_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/index.js
// module id = 72
// module chunks = 0 1